import Backbone from "backbone";

import _ from "underscore";

function urlError() {
  throw new Error('A "url" property or function must be specified');
}

// Map from CRUD to HTTP for our default `Backbone.sync` implementation.
const methodMap = {
  'create': 'POST',
  'update': 'PUT',
  'patch':  'PUT',
  'delete': 'DELETE',
  'read':   'GET'
};

// custom sync implementation for Invoca defaults, much of it taken from
// Backbone's default #sync implementation
export default function sync(method, model, options) {
  var type = methodMap[method];
  options || (options = {});

  // Default JSON-request options.
  var params = { type: type, dataType: 'json' };

  // Ensure that we have a URL.
  // Additionally specifying a ".json" suffix on all urls
  if (!options.url) {
    params.url = _.result(model, 'url') || urlError();
    if (params.url.indexOf(".json") === -1) {
      if (params.url.indexOf("?") === -1) {
        params.url += ".json";
      } else {
        var index = params.url.indexOf("?");
        var newUrl = [params.url.slice(0, index), ".json", params.url.slice(index)].join('');
        params.url = newUrl;
      }
    }
  } else {
    if (!params.url) {
      params.url = options.url;
    }
  }

  // ensure that the ajax=1 param is always sent
  if (method === "read") {
    if (params.url.indexOf("ajax=1") === -1) {
      params.url += (params.url.indexOf("?") === -1 ? "?" : "&") + "ajax=1";
    }
  }

  // ensure that we have the appropriate request data and that the ajax=1 param is always sent
  if (method === "delete") {
    params.contentType = 'application/json';
    params.data = JSON.stringify({ ajax: 1 });
  } else if (!options.data && model && (method === 'create' || method === 'update' || method === 'patch')) {
    params.contentType = 'application/json';
    var data = _.extend({ ajax: 1 }, options.attrs || model.toJSON(options));
    params.data = JSON.stringify(data);
  }

  // And an `X-HTTP-Method-Override` header.
  if (type === 'PUT' || type === 'DELETE' || type === 'PATCH') {
    params.type = 'POST';
    var beforeSend = options.beforeSend;
    options.beforeSend = function(xhr) {
      xhr.setRequestHeader('X-HTTP-Method-Override', type);
      if (beforeSend) {
        return beforeSend.apply(this, arguments);
      }
    };
  }

  // Don't process data on a non-GET request.
  if (params.type !== 'GET') {
    params.processData = false;
  }

  // If we're sending a `PATCH` request, and we're in an old Internet Explorer
  // that still has ActiveX enabled by default, override jQuery to use that
  // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
  const noXhrPatch =
    typeof window !== 'undefined' && !!window.ActiveXObject &&
    !(window.XMLHttpRequest && (new XMLHttpRequest()).dispatchEvent);

  if (params.type === 'PATCH' && noXhrPatch) {
    params.xhr = function() {
      return new window.ActiveXObject("Microsoft.XMLHTTP");
    };
  }

  var beforeSendForBackdraft = options.beforeSend;
  options.beforeSend = function(xhr) {
    xhr.setRequestHeader('X-Backdraft', "1");
    if (beforeSendForBackdraft) {
      return beforeSendForBackdraft.apply(this, arguments);
    }
  };

  // Make the request, allowing the user to override any Ajax options.
  var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
  model.trigger('request', model, xhr, options);
  return xhr;
}
